/* eslint-disable
    func-names,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
const deps = ['Api'];
const factory = function (Api) {
  class MainApi extends Api {
    constructor() {
      super('main');
    }
  }

  return new MainApi();
};

factory.$inject = deps;
module.exports = factory;
